// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2AU0Y","head":"ProcedureTableInfo_head__ZKZnY"};